import { action as apiAction } from 'api/Api'
import {
  add as addChecklist,
  set as setChecklist
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  name: string
  index?: number
}

export default (payload: Payload) => async dispatch => {
  const { cardId, name, index } = payload

  const tempId = `temp-${new Date().getTime()}`

  const optimisticAction = optimisticDispatch(dispatch, addChecklist({
    cardId,
    element: {
      id: tempId,
      elementName: '/Data/Checklist',
      name: name.trim(),
      items: [],
      isBusy: true,
      index
    }
  }))

  try {
    const Checklist = await apiAction('AddChecklist', {
      cardId,
      name: name.trim(),
      position: index
    })

    dispatch(setChecklist({
      cardId,
      element: {
        id: Checklist.Id,
        isNewlyAdded: true
      }
    }))
  } finally {
    optimisticAction.revert()
  }
}
